import { useState } from 'react';

const useRadioButtonValue = initialValue => {
  const [data, setData] = useState(initialValue);
  const onChange = event => setData(event.target.value)

  return { onChange, setData, data };
};

export default useRadioButtonValue;
